<app-family-landing>
  <app-reset-password [loginUrl]="'/auth/family/login'"></app-reset-password>
</app-family-landing>
